import React from "react";
import * as T from "prop-types";

import { Field, Inputs } from "2g-form";

import { ZdrojFull } from "b2b/renderers/ciselnik/";

import useMessages from "./i18n/useMessages";
import { useZdrojeFromZdrojeTyp } from "b2b/api/hooks";

export function ACZdrojeFromZdrojeTyp({ ...props }) {
  const { zdrojLabel, zdrojPlaceholder } = useMessages();
  const { data: zdroje } = useZdrojeFromZdrojeTyp();
  return (
    <Field
      component={Inputs.AutoComplete}
      rendererSelected={ZdrojFull}
      rendererOption={ZdrojFull}
      staticData={zdroje}
      staticKey={["nazevCs", "nazevEn"]}
      minChars={0}
      label={zdrojLabel()}
      placeholder={zdrojPlaceholder()}
      descriptionRenderer={ZdrojFull}
      {...props}
    />
  );
}

ACZdrojeFromZdrojeTyp.propTypes = {
  multiple: T.bool
};

export default React.memo(ACZdrojeFromZdrojeTyp);
